import { render, staticRenderFns } from "./event_list.vue?vue&type=template&id=68468e2b&scoped=true&"
import script from "./event_list.vue?vue&type=script&lang=js&"
export * from "./event_list.vue?vue&type=script&lang=js&"
import style0 from "./event_list.vue?vue&type=style&index=0&id=68468e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68468e2b",
  null
  
)

export default component.exports